import { logInfo } from "./log";

interface StabilityOptions {
  timeout?: number;
  stability?: number;
}

export const waitForDOMStability = (
  options: StabilityOptions = {}
): Promise<boolean> => {
  const { timeout = 1200, stability = 200 } = options;

  const startTime = Date.now();

  return new Promise((resolve) => {
    let stabilityTimer: ReturnType<typeof setTimeout>;
    let timeoutTimer: ReturnType<typeof setTimeout>;

    const observer = new MutationObserver(() => {
      clearTimeout(stabilityTimer);
      stabilityTimer = setTimeout(() => {
        cleanup();
        const duration = Date.now() - startTime;
        logInfo(`DOM stabilized after ${duration}ms`);
        resolve(true);
      }, stability);
    });

    const cleanup = () => {
      clearTimeout(stabilityTimer);
      clearTimeout(timeoutTimer);
      observer.disconnect();
    };

    timeoutTimer = setTimeout(() => {
      cleanup();
      const duration = Date.now() - startTime;
      logInfo(`Timed out after ${duration}ms`);
      resolve(false);
    }, timeout);

    observer.observe(document.body, {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true,
    });
  });
};
